export default function Go_Loops () {
  return (
    <div>
      <h1>Go_Loops </h1>
      <p>Go Loops</p>
    </div>
  );
}